import React from "react";
import "../FinTechConsulting.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import { Link } from "react-router-dom";

import {
    FiChevronRight,
    FiTrendingUp,
    FiShield,
    FiDatabase,
    FiCpu,
    FiCreditCard,
    FiBarChart2,
    FiCheckCircle,
    FiUsers
} from "react-icons/fi";


const FinTechConsulting = () => {

    return (

        <>

            <Header />


            <div className="fintech-consulting-page">


                {/*=====================================================
                    HERO
======================================================*/}


                <section className="fc-hero">

                    <div className="container">


                        <div className="fc-hero-content">


                            <span className="fc-tag">

                                FINTECH CONSULTING

                            </span>


                            <h1>

                                Strategic Consulting For
                                <span> Digital Financial Transformation</span>

                            </h1>


                            <p>

                                We help banks, NBFCs, payment providers, insurance
                                companies, and fintech startups build secure,
                                scalable, and future-ready financial technology
                                strategies through expert consulting and industry
                                best practices.

                            </p>


                            <div className="fc-buttons">


                                <a
                                    href="/contact"
                                    className="fc-primary-btn">

                                    Talk To Experts

                                </a>


                                {/* <Link
                                    to="/services"
                                    className="fc-secondary-btn">

                                    Explore Services

                                </Link> */}


                            </div>


                        </div>


                    </div>

                </section>



                {/*=====================================================
                    BREADCRUMB
======================================================*/}


                <section className="fc-breadcrumb">

                    <div className="container">

                        <Link to="/">Home</Link>

                        <FiChevronRight />

                        <Link to="/solutions">
                            Solutions
                        </Link>

                        <FiChevronRight />

                        <span>
                            FinTech Consulting
                        </span>


                    </div>

                </section>



                {/*=====================================================
                    OVERVIEW
======================================================*/}


                <section className="fc-overview">


                    <div className="container">


                        <div className="fc-grid">


                            <div className="fc-content">


                                <span className="section-tag">

                                    OVERVIEW

                                </span>


                                <h2>

                                    Transforming Financial Businesses
                                    <span> Through Strategic Technology</span>

                                </h2>


                                <p>

                                    Our FinTech Consulting services help organizations
                                    navigate digital transformation by combining financial
                                    industry expertise with modern technology strategies.

                                </p>


                                <p>

                                    From technology assessment and digital roadmap
                                    planning to compliance strategy and operational
                                    optimization, we help businesses make informed
                                    technology decisions.

                                </p>



                                <div className="fc-check-list">


                                    <div>
                                        <FiCheckCircle />
                                        Secure Technology Planning
                                    </div>


                                    <div>
                                        <FiCheckCircle />
                                        Digital Banking Strategy
                                    </div>


                                    <div>
                                        <FiCheckCircle />
                                        Process Optimization
                                    </div>


                                    <div>
                                        <FiCheckCircle />
                                        Technology Advisory
                                    </div>


                                </div>


                            </div>



                            <div className="fc-dashboard">


                                <div className="fc-dashboard-card">

                                    <FiTrendingUp />

                                    <h3>
                                        Digital Strategy
                                    </h3>

                                    <span>
                                        Growth Roadmap
                                    </span>

                                </div>



                                <div className="fc-dashboard-card">

                                    <FiShield />

                                    <h3>
                                        Risk Management
                                    </h3>

                                    <span>
                                        Compliance Ready
                                    </span>

                                </div>



                                <div className="fc-dashboard-card">

                                    <FiCpu />

                                    <h3>
                                        Automation
                                    </h3>

                                    <span>
                                        Smart Operations
                                    </span>

                                </div>



                                <div className="fc-dashboard-card">

                                    <FiDatabase />

                                    <h3>
                                        Data Analytics
                                    </h3>

                                    <span>
                                        Better Decisions
                                    </span>

                                </div>


                            </div>


                        </div>

                    </div>

                </section>





                {/*=====================================================
                CONSULTING SERVICES
======================================================*/}


                <section className="fc-services">


                    <div className="container">


                        <div className="section-heading">

                            <span className="section-tag">
                                OUR EXPERTISE
                            </span>


                            <h2>

                                FinTech Consulting
                                <span> Capabilities</span>

                            </h2>


                        </div>



                        <div className="fc-service-grid">



                            {
                                [
                                    ["💳", "Digital Banking Strategy",
                                        "Develop technology strategies that improve banking experiences and operational efficiency."],

                                    ["🛡", "Compliance Consulting",
                                        "Build compliance-driven processes aligned with financial regulations."],

                                    ["⚡", "Technology Advisory",
                                        "Identify the right platforms, APIs, and architectures for your business."],

                                    ["📊", "Business Process Optimization",
                                        "Improve workflows through automation and intelligent solutions."],

                                    ["☁", "Cloud Transformation",
                                        "Move financial operations towards scalable cloud infrastructure."],

                                    ["🤖", "FinTech Innovation",
                                        "Adopt AI, automation, and emerging technologies."]
                                ].map((item, index) => (


                                    <div className="fc-service-card" key={index}>


                                        <div className="fc-icon">
                                            {item[0]}
                                        </div>


                                        <h3>
                                            {item[1]}
                                        </h3>


                                        <p>
                                            {item[2]}
                                        </p>


                                    </div>


                                ))


                            }



                        </div>


                    </div>


                </section>





                {/*=====================================================
                APPROACH
======================================================*/}


                <section className="fc-process">


                    <div className="container">


                        <div className="section-heading">

                            <span className="section-tag">
                                OUR APPROACH
                            </span>


                            <h2>

                                Consulting Process
                                <span> We Follow</span>

                            </h2>

                        </div>



                        <div className="fc-process-grid">


                            {
                                [
                                    "Business Assessment",
                                    "Technology Analysis",
                                    "Strategic Roadmap",
                                    "Solution Planning",
                                    "Implementation Support",
                                    "Continuous Improvement"

                                ].map((item, index) => (


                                    <div className="fc-process-card"
                                        key={index}>


                                        <div>
                                            0{index + 1}
                                        </div>


                                        <h3>
                                            {item}
                                        </h3>


                                    </div>


                                ))

                            }


                        </div>



                    </div>


                </section>






                {/*=====================================================
                    BENEFITS
======================================================*/}


                <section className="fc-benefits">


                    <div className="container">


                        <div className="section-heading">

                            <span className="section-tag">
                                BUSINESS BENEFITS
                            </span>


                            <h2>

                                Why Choose Our
                                <span> Consulting Services</span>

                            </h2>

                        </div>



                        <div className="fc-benefit-grid">


                            <div>
                                <FiTrendingUp />
                                <h3>Business Growth</h3>
                                <p>Accelerate innovation and improve operational performance.</p>
                            </div>


                            <div>
                                <FiShield />
                                <h3>Better Security</h3>
                                <p>Design secure and compliance-focused financial systems.</p>
                            </div>


                            <div>
                                <FiUsers />
                                <h3>Expert Guidance</h3>
                                <p>Get support from fintech technology specialists.</p>
                            </div>


                            <div>
                                <FiBarChart2 />
                                <h3>Data Driven Decisions</h3>
                                <p>Use analytics to improve financial operations.</p>
                            </div>


                        </div>


                    </div>


                </section>







                


            </div>


            <Footer />

        </>

    )

}


export default FinTechConsulting;